import { CommonModule, formatNumber } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IAboutCompanyStats, IAboutCompanyValues } from './about.model';
import { Router } from '@angular/router';
import { UtilService } from '../../Utils/_services/utils/util.service';
import { ICustomError } from '../../Utils/_models/network-response';
import { IUtil_GetAllRepoClocResponse } from '../../Utils/_services/utils/util.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent implements OnInit {
  values: Array<IAboutCompanyValues> = [
    {
      icon: "💡",
      title: "Innovation",
      description: "Pushing boundaries with creative solutions",
    },
    {
      icon: "🤝",
      title: "Integrity",
      description: "Building trust through transparency",
    },
    {
      icon: "🎯",
      title: "Customer Focus",
      description: "Your success is our priority",
    },
    {
      icon: "👥",
      title: "Collaboration",
      description: "Achieving more together",
    },
  ]

  stats: Array<IAboutCompanyStats> = [
    { number: "500+", label: "Projects Completed" },
    { number: "50+", label: "Happy Clients" },
    { number: `0+`, label: "Lines of Code" },
    { number: "5+", label: "Years Experience" },
    { number: "24/7", label: "Support Available" },
  ]

  public clocRepo: IUtil_GetAllRepoClocResponse = {
    totalCombined: 0,
    totalFiles: 0,
    totalCode: 0,
    totalBlank: 0,
    totalComment: 0
  }

  constructor(private appService: UtilService,
      private router: Router,
      private toastr: ToastrService
    ) {}

  ngOnInit(): void {
    this.loadClocRepo();
  }

  loadClocRepo(): void {
    this.appService.getGetAllRepoCloc()
    .subscribe({
      next: (response) => {
        this.clocRepo = response.data;
        console.log("clocRepo", this.clocRepo);
      },
      error: (err: ICustomError) => {
        console.error('Failed to load all cloc repo:', err.error);
        this.toastr.error('Error loading cloc repo. Please try again.', 'Error');
      }
    });
  }

  onContactUs() {
    this.router.navigate(["/contact"]);
  }

  onViewProject() {
    this.router.navigate(["/"]);
  }
}
